import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, Navigate } from 'react-router-dom'

import {
	Button,
	Input,
	PageTransition,
	Icon,
	SelectBase,
	NumberInput,
} from '@components/atoms'
import { SliderLogin } from '@components/molecules'
import { yupResolver } from '@hookform/resolvers/yup'
import { signUpSchema } from '@schemas/auth/login.schema'
import { authApi } from '@services/AuthApi'
import { authCreators } from '@store/ducks/auth'
import { useAppDispatch, useAppSelector } from '@store/hooks'

import { signStyles } from './styles'

const { background, container } = signStyles

type FormValues = {
	name: string
	email: string
	password: string
	interest: string
	phone: string
}

export type InterestSelectType = {
	selectInterest: { value: string }
}

export default function SignUp() {
	const {
		register,
		handleSubmit,
		setValue,
		watch,
		formState: { errors },
	} = useForm<FormValues>({
		resolver: yupResolver(signUpSchema),
	})

	const { email, name } = watch()

	const dispatch = useAppDispatch()
	const [values, setValues] = useState<InterestSelectType>()
	const {
		auth: { signed },
		/* 		error: { message, show }, */
	} = useAppSelector((state) => state)

	const [signUp, { isLoading, isSuccess, data }] = authApi.useSignUpMutation()

	useEffect(() => {
		if (isSuccess && data) {
			window.dataLayer.push({
				event: 'form_submit',
				eventModel: {
					name,
					email,
				},
			})

			dispatch(authCreators.authenticate({ token: data.token }))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, isSuccess, data])

	// eslint-disable-next-line no-console
	const onSubmit = handleSubmit((payload) => {
		signUp(payload)
		dispatch(authCreators.setNewSession())
	})

	useEffect(() => {
		if (values?.selectInterest?.value) {
			setValue('interest', values?.selectInterest?.value)
		}
	}, [setValue, values])

	return (
		<PageTransition>
			{signed && <Navigate to='/' />}
			<main className={background()}>
				<div className={container()}>
					<div className='content'>
						<Link to='/'>
							<Icon title='logo DLS' name='logo' width={116} height={50} />
						</Link>
					</div>
					<div className='content'>
						<div className='titles'>
							<h4>Cadastre-se</h4>
							<p>Insira suas informações abaixo.</p>
						</div>

						<form onSubmit={onSubmit}>
							<Input
								placeholder='Nome'
								error={errors.name?.message}
								{...register('name')}
							/>
							<Input
								placeholder='Email'
								error={errors.email?.message}
								{...register('email')}
							/>
							<Input
								placeholder='Senha'
								type='password'
								error={errors.password?.message}
								{...register('password')}
							/>
							<NumberInput
								placeholder='Telefone'
								error={errors.phone?.message}
								{...register('phone')}
								css={{ marginBottom: 0, color: '$neutral120' }}
								onValueChange={(v) => setValue('phone', v.value)}
								defaultValue=''
								format='(##) #####-####'
							/>

							<SelectBase
								placeholder='Selecione uma área de interesse'
								options={[
									{
										value: 'Carreiras Jurídicas',
										label: 'Carreiras Jurídicas',
									},
									{
										value: 'Carreiras Policiais',
										label: 'Carreiras Policiais',
									},
									{ value: 'Procuradorias', label: 'Procuradorias' },
									{ value: 'Cartórios', label: 'Cartórios' },
									{ value: 'Tribunais', label: 'Tribunais' },
									{ value: 'OAB', label: 'OAB' },
									{ value: 'Outros', label: 'Outros' },
								]}
								name='selectInterest'
								onChange={setValues}
								error={errors?.interest?.message}
								css={{ div: { maxHeight: '177px' } }}
							/>
							<Button onClick={onSubmit} loading={isLoading}>
								Cadastrar
							</Button>
						</form>

						<h5>
							Já tenho cadastro:{' '}
							<Link className='link' to='/login'>
								Entrar
							</Link>
						</h5>
					</div>
				</div>

				<SliderLogin />
			</main>
		</PageTransition>
	)
}
